import { type FC } from 'react';
import { graphql, useFragment } from 'react-relay';

// components
import { PdpRespTitle } from '../../PdpRespTitle/PdpRespTitle';

// types
import { type PdpRespSharedTitle_item$key as Item } from './__generated__/PdpRespSharedTitle_item.graphql';

const itemQuery = graphql`
    fragment PdpRespSharedTitle_item on Item {
        ...PdpRespTitle_item
    }
`;
export const PdpRespSharedTitle: FC<{
    item: Item;
    isUnavailablePdp?: boolean;
    isPDPDesktopAggregationVariant?: boolean | null;
    isPdpPricingOptimizationVariant?: boolean | null;
}> = ({
    item: itemRef,
    isUnavailablePdp,
    isPDPDesktopAggregationVariant,
    isPdpPricingOptimizationVariant,
}) => {
    const item = useFragment(itemQuery, itemRef);

    return (
        <PdpRespTitle
            item={item}
            isUnavailablePdp={isUnavailablePdp}
            isPDPDesktopAggregationVariant={isPDPDesktopAggregationVariant}
            isPdpPricingOptimizationVariant={isPdpPricingOptimizationVariant}
        />
    );
};
